<template>
  <div class="flex flex--center one-whole">
    <ak-icon
      v-if="isOpen"
      style="line-height: 1.3"
      type="folder-open"
      :class="{ 'text-grey': isActive(folder._id) }"
    />
    <ak-icon
      v-if="!isOpen"
      style="line-height: 1.3"
      type="folder"
      :class="{ 'text-grey': isActive(folder._id) }"
    />
    <tree-display-item
      :title="folder.title"
      :hidden="isHidden"
      :activity="folder.agencyActivity"
      :active="isActive(folder._id)"
    />
    <folder-dropdown
      :item="folder"
      :children="folderChildren"
      @update="update"
    />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, inject, computed } from 'vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import TreeDisplayItem from './TreeDisplayItem.vue'
import FolderDropdown from './dropdowns/FolderDropdown.vue'
import { display, userHigherThan } from './utils'
export default defineComponent({
  name: 'FolderItem',
  components: {
    [Icon.name]: Icon,
    [TreeDisplayItem.name]: TreeDisplayItem,
    [FolderDropdown.name]: FolderDropdown,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    children: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const folder = ref({})
    const updateData = inject('updateData')
    const isActive = inject('isActive')

    const update = async (withFetch = true) => {
      if (!withFetch) {
        folder.value = props.item
      } else {
        await updateData()
        folder.value = props.item
      }
    }

    const isHidden = computed(() => {
      return folder.value.hidden && userHigherThan('agencyuser')
    })

    const getChildren = (children) => {
      let array = []
      children.forEach((child) => {
        if (child.data && child.data._id) {
          array.push(child.data._id)
        }
        if (child.children && child.children.length > 0) {
          array = [...array, ...getChildren(child.children)]
        }
      })
      return array
    }

    const folderChildren = computed(() => {
      return getChildren(props.children)
    })

    onMounted(() => {
      update(false)
    })

    return {
      folder,
      folderChildren,
      isHidden,
      isActive,
      update,
      display,
    }
  },
})
</script>
